import React, { useEffect, useState } from "react";
import TextMedium from "../TextComponent/TextMedium";
import {
  handleFilterManagerGroup,
  activeFiltersManager,
  handleFilterManagerChannel,
  handleFilterManagerStatus,
  handleFilterManagerService,
} from "../../../actions";
import { ReactComponent as ColumnFilterIcon } from "../../../build/images/icons/ColumnFilterIcon.svg";
import { ReactComponent as MessengerIcon } from "../../../build/images/icons-channels/messenger.svg";
import { ReactComponent as WhatsappIcon } from "../../../build/images/icons-channels/whatsapp.svg";
import { ReactComponent as WhatsappVoiceIcon } from "../../../build/images/whatsapp_voice.svg";
import { ReactComponent as FacebookIcon } from "../../../build/images/icons-channels/facebook.svg";
import { ReactComponent as TelegramIcon } from "../../../build/images/telegramicon.svg";
import { ReactComponent as GOOGLEGBM } from "../../../build/images/icons-channels/googlegbm-large.svg";
import { ReactComponent as VozIcon } from "../../../build/images/icons-channels/voz.svg";
import { ReactComponent as EmailIcon } from "../../../build/images/icons-channels/email.svg";
import { ReactComponent as WebchatIcon } from "../../../build/images/icons-channels/webchat.svg";
import { ReactComponent as InstaIcon } from "../../../build/images/iconmediainsta.svg";
import { ReactComponent as EmptyState } from "../../../build/images/emptystatemanagerhorizontal.svg";
import { ReactComponent as TEAMS } from "../../../build/images/channelsNew/teamsBig.svg";
import LoadingTable from "../../../build/images/Column.png";
import PopoverColumnsFilter from "../../popovercolumnsfilter/PopoverColumnsFilter";
import Table from "../../table";
import { useDispatch, useSelector } from "react-redux";

let columns = [];
let exhibColumn = [];
let TimeFormat = require("hh-mm-ss");

let serviceDataFiltered = [];

function defaultSorting(rowA, rowB, columnId) {
  const objectRowA = rowA.original[columnId].data;
  const objectRowB = rowB.original[columnId].data;

  if (objectRowA > objectRowB) return -1;
  if (objectRowB > objectRowA) return 1;
  return 0;
}

function chooseDisplay(nameDisplay) {
  const indexFind = exhibColumn.findIndex(
    (column) => column.title.toLowerCase() === nameDisplay.toLowerCase(),
  );

  return exhibColumn[indexFind].exhib;
}

export default function CardTableService({ title, data }) {
  const columnsAllServiceManager = useSelector(
    (state) => state.columnsallservices,
  );
  const serviceGroup = useSelector((state) => state.servicegroup);
  const [serviceData, setServiceData] = useState([]);
  const LoginCompleteReducer = useSelector((state) => state.ipcurrent);
  const FiltersManager = useSelector((state) => state.filtersmanager);
  const QueueReducer = useSelector((state) => state.listcallqueue);
  const userReduce = useSelector((state) => state.informationusers);
  const dispatch = useDispatch();

  useEffect(() => {
    if (serviceGroup.length !== 0) {
      let status = localStorage.getItem("managernew_filter_status");
      let group = localStorage.getItem("managernew_filter_group");
      let service = localStorage.getItem("managernew_filter_service");
      let channel = localStorage.getItem("managernew_filter_channel");

      if (
        status === null &&
        group === null &&
        service === null &&
        channel === null
      ) {
        let markFilterGroup = JSON.parse(serviceGroup.json);
        let temp = [];

        markFilterGroup.map((mark) => {
          temp = temp.concat([parseInt(mark.idgrupo)]);
        });

        dispatch(handleFilterManagerGroup([userReduce.idgroup]));
        localStorage.setItem("managernew_filter_group", [userReduce.idgroup]);

        dispatch(handleFilterManagerChannel([1, 2, 4, 5, 6, 8]));
        localStorage.setItem("managernew_filter_channel", [1, 2, 4, 5, 6, 8]);

        dispatch(handleFilterManagerStatus([1, 2, 3, 4, 5]));
        localStorage.setItem("managernew_filter_status", [1, 2, 3, 4, 5]);

        dispatch(handleFilterManagerService(temp));
        localStorage.setItem("managernew_filter_service", temp);

        dispatch(activeFiltersManager());
      }
    }
  }, [serviceGroup]);

  useEffect(() => {
    let serviceRefactored = [];
    let qtdFila = [];

    if (serviceGroup.length !== 0 && FiltersManager.is_active) {
      let jsonSRV = JSON.parse(serviceGroup.json);

      jsonSRV = jsonSRV.filter((filt) =>
        FiltersManager.filter_manager_service.includes(filt.idgrupo),
      );
      jsonSRV = jsonSRV.filter((filt) =>
        FiltersManager.filter_manager_channel.includes(filt.idmidia),
      );

      jsonSRV.map((datum) => {
        qtdFila = QueueReducer.filter((queue) =>
          datum.subservico.includes(parseInt(queue.serviceinid)),
        );
        qtdFila = qtdFila.filter((queue) => parseInt(queue.status) === 1);
        qtdFila = qtdFila.filter(
          (queue) => parseInt(queue.mediaid) === parseInt(datum.idmidia),
        );

        let qtdeAbdn = 0;
        if (datum.idmidia === 1) {
          if (datum.qtde_abandonada - qtdFila.length > 0)
            qtdeAbdn = datum.qtde_abandonada - qtdFila.length;
        } else {
          qtdeAbdn = datum.qtde_abandonada;
        }
        serviceRefactored.push({
          service: {
            data: datum.nomegrupo,
            config: {
              className: "cell-gray-text",
              filterValue: "",
              customOrder: "",
              textEllipsis: false,
              customData: false,
              favorite: true,
              read: true,
              filter: "",
            },
          },
          channels: {
            data: (
              <div className="manager-box-channels">
                {datum.idmidia === 5 && <WhatsappIcon />}
                {datum.idmidia === 2 && <WebchatIcon />}
                {datum.idmidia === 3 && <WebchatIcon />}
                {datum.idmidia === 4 && <FacebookIcon />}
                {datum.idmidia === 6 && <InstaIcon />}
                {datum.idmidia === 8 && <TelegramIcon />}
                {datum.idmidia === 10 && <MessengerIcon />}
                {datum.idmidia === 7 && <EmailIcon />}
                {datum.idmidia === 1 && <VozIcon />}
                {datum.idmidia === 11 && <GOOGLEGBM />}
                {datum.idmidia === 15 && <TEAMS />}
                {datum.idmidia === 16 && <WhatsappVoiceIcon />}
              </div>
            ),
            config: {
              className: "",
            },
          },
          performed: {
            data: datum.qtde_recebidas,
            config: {
              textEllipsis: true,
            },
          },
          attended: {
            data: datum.qtde_atendidas,
            config: {
              textEllipsis: true,
            },
          },
          tma: {
            data:
              datum.tmatendida !== null
                ? TimeFormat.fromS(parseInt(datum.tmatendida), "hh:mm:ss")
                : "00:00:00",
            config: {
              textEllipsis: true,
            },
          },
          queue: {
            data: qtdFila.length,
            config: {
              textEllipsis: true,
            },
          },
          tme: {
            data:
              datum.tmespera !== null
                ? TimeFormat.fromS(parseInt(datum.tmespera), "hh:mm:ss")
                : "00:00:00",
            config: {
              textEllipsis: true,
            },
          },
          abandoned: {
            data: qtdeAbdn,
            config: {
              textEllipsis: true,
            },
          },
          tm_a: {
            data:
              datum.tmabandonada !== null
                ? TimeFormat.fromS(parseInt(datum.tmabandonada), "hh:mm:ss")
                : "00:00:00",
            config: {
              textEllipsis: true,
            },
          },
          transfered: {
            data: datum.qtde_transferida,
            config: {
              textEllipsis: true,
            },
          },
          tmr: {
            data:
              datum.tempo_medio !== null && datum.tempo_medio !== undefined
                ? TimeFormat.fromS(parseInt(datum.tempo_medio), "hh:mm:ss")
                : "00:00:00",
            config: {
              textEllipsis: true,
            },
          },
        });
      });
      serviceDataFiltered = serviceRefactored;
      setServiceData(serviceRefactored);
    }
  }, [serviceGroup, FiltersManager, QueueReducer]);

  exhibColumn = [
    {
      title: "Serviço",
      exhib: true,
    },
    {
      title: "Canais",
      exhib: true,
    },
    {
      title: "Recebidas",
      exhib: columnsAllServiceManager.performed,
    },
    {
      title: "Atendidas",
      exhib: columnsAllServiceManager.attended,
    },
    {
      title: "TMA",
      exhib: columnsAllServiceManager.tma,
    },
    {
      title: "Fila",
      exhib: columnsAllServiceManager.queue,
    },
    {
      title: "TME",
      exhib: columnsAllServiceManager.tme,
    },
    {
      title: "Abandonadas",
      exhib: columnsAllServiceManager.abandoned,
    },
    {
      title: "TM. A.",
      exhib: columnsAllServiceManager.tm_a,
    },
    {
      title: "Transferidas",
      exhib: columnsAllServiceManager.transfered,
    },
    {
      title: "TMR",
      exhib: columnsAllServiceManager.tmr,
    },
  ];

  columns = [
    {
      Header: "Serviço",
      accessor: "service",
      Hint: "Serviço",
      id: "service",
      disableFilters: true,
      sortType: defaultSorting,
      display: chooseDisplay("Serviço"),
    },
    {
      Header: "Canais",
      accessor: "channels",
      Hint: "Canais",
      id: "channels",
      disableFilters: true,
      sortType: defaultSorting,
      display: chooseDisplay("Canais"),
    },
    {
      Header: "Recebidas",
      accessor: "performed",
      Hint: "Recebidas",
      id: "performed",
      sortType: defaultSorting,
      disableFilters: true,
      display: chooseDisplay("Recebidas"),
    },
    {
      Header: "Atendidas",
      accessor: "attended",
      Hint: "Atendidas",
      id: "attended",
      sortType: defaultSorting,
      disableFilters: true,
      display: chooseDisplay("Atendidas"),
    },
    {
      Header: "TMA",
      accessor: "tma",
      Hint: "Tempo médio de atendimento",
      id: "tma",
      sortType: defaultSorting,
      disableFilters: true,
      display: chooseDisplay("TMA"),
    },
    {
      Header: "Fila",
      accessor: "queue",
      Hint: "Fila",
      id: "queue",
      sortType: defaultSorting,
      disableFilters: true,
      display: chooseDisplay("Fila"),
    },
    {
      Header: "TME",
      accessor: "tme",
      Hint: "Tempo médio de espera para atendimento",
      id: "tme",
      disableFilters: true,
      sortType: defaultSorting,
      display: chooseDisplay("TME"),
    },
    {
      Header: "Abandonadas",
      accessor: "abandoned",
      Hint: "Abandonadas",
      id: "abandoned",
      sortType: defaultSorting,
      disableFilters: true,
      display: chooseDisplay("Abandonadas"),
    },
    {
      Header: "TM. A.",
      accessor: "tm_a",
      Hint: "Tempo médio de abandono",
      id: "tm_a",
      sortType: defaultSorting,
      disableFilters: true,
      display: chooseDisplay("TM. A."),
    },
    {
      Header: "Transferidas",
      accessor: "transfered",
      Hint: "Transferidas",
      id: "transfered",
      sortType: defaultSorting,
      disableFilters: true,
      display: chooseDisplay("Transferidas"),
    },
    {
      Header: "TMR",
      accessor: "tmr",
      Hint: "Tempo médio de resposta",
      id: "tmr",
      sortType: defaultSorting,
      disableFilters: true,
      display: chooseDisplay("TMR"),
    },
  ];

  let checkSort = localStorage.getItem("sortMarkedService")
    ? JSON.parse(localStorage.getItem("sortMarkedService"))
    : "";

  let sortBy = {
    sortBy: [],
  };

  if (checkSort !== "") {
    sortBy = {
      sortBy: [
        {
          id: checkSort ? checkSort.sort : "service",
          desc: checkSort ? checkSort.sortDesc : false,
        },
      ],
    };
  }

  return (
    <div className="manager-component__card-table">
      <div className="manager-component__card-table__box">
        <div className="manager-component__card-table__title">
          <TextMedium text={title} color="gray" />
        </div>
        <PopoverColumnsFilter
          className={"filters-columns"}
          placement="bottom-end"
          menuData={exhibColumn}
          screen="manager"
        >
          <div className="email__container-subheader__actionsTwo">
            <ColumnFilterIcon />
            <span className="email__container-subheader__actionsTwo-span">
              Colunas
            </span>
          </div>
        </PopoverColumnsFilter>
      </div>
      <div className="manager-component__card-table__area">
        {LoginCompleteReducer.isLoginComplete ? (
          serviceDataFiltered.length !== 0 ? (
            <Table
              className="table-cases"
              data={serviceDataFiltered}
              columns={columns}
              fixedHeader
              // fixedFirstColumn
              // filtersActive={filtersActive}
              // emptyState={emptyState}
              // setEmptyState={setEmptyState}
              initialState={sortBy}
              screen="manager"
            />
          ) : (
            <div className="manager-component__card-table__area-empty">
              <EmptyState />
            </div>
          )
        ) : (
          <img src={LoadingTable} alt="loading" />
        )}
      </div>
    </div>
  );
}
